<template>
  <div>
    <loadingComponent :loading="loading">
      <a-row :gutter="10">
        <a-col
          :xs="12"
          :sm="12"
          :md="8"
          v-for="(item, index) in list"
          :key="index"
          class="company-card-col"
        >
          <companyCard :data="item"></companyCard>
        </a-col>
      </a-row>
    </loadingComponent>
    <t100-pagination
      v-model="currentPage"
      :total="total"
      :pageSize="6"
      @change="handleChange"
    ></t100-pagination>
  </div>
</template>
<script>
import companyCard from "@/views/home/components/company-module/company-card";
import loadingComponent from "@/components/loadingComponent";
import * as API from "@/api";
export default {
  components: { companyCard, loadingComponent },
  props: ["type", "keyword"],
  data() {
    return {
      currentPage: 1,
      total: 0,
      loading: false,
      list: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page = 1) {
      this.loading = true;
      const data = {
        page: page,
        per_page: 6,
        type: this.type,
        name: this.keyword,
      };
      const res = await API.getCompanyList(data);
      this.list = res.data;
      this.total = res.meta.pagination.total;
      this.currentPage = res.meta.pagination.current_page;
      this.loading = false;
    },
    handleChange(page) {
      this.getData(page);
    },
  },
};
</script>
<style lang="less">
.pagination-small {
  li {
    color: #fff!important;
  }
}
</style>